export default (data = {}) => {
    return {
        id_pos: null,
        sku: null,
        ean: null,
        categoria: null,
        grupo: null,
        marca: null,
        refe: null,
        color: null,
        talla: null,
        cantidad: null,
        precio: null,
        precioB: null,
        precioC: null,
        precioD: null,
        // tacon: null,
        // suela: null,
        // msuela: null,
        // mzapato: null,
        audit: null,
        descuento: null,
        ...data
    }
}
